import React from 'react';

export default function OutfitCardSkeleton() {
  return (
    <div
      className="pdp-outfit-card loading"
      data-testid="outfit-card-skeleton"
      aria-hidden="true"
    >
      <div className="pdp-outfitting-skeleton-image" />
    </div>
  );
}
